export const TRAVELMALL = 'TRAVELMALL';

export const DRAWERSHOW = 'DRAWERSHOW';
export const DRAWERCLOSE = 'DRAWERCLOSE';

export const OTHERDRAWERSHOW = 'OTHERDRAWERSHOW';
export const OTHERDRAWERCLOSE = 'OTHERDRAWERCLOSE';

// 常见问题/预订说明
export const CUSTOMIZEDTRAVEL = 'CUSTOMIZEDTRAVEL';
export const FAQ = 'FAQ';
export const BOOKINGINSTRUCTIONS = 'BOOKINGINSTRUCTIONS';

// 定制旅行
export const domesticTourType = 'domesticTour';
export const overseasTourType = 'overseasTour';


// 选择想去的目的地
export const domesticTitle = 'domesticTitle';
export const overseasTitle = 'overseasTitle';
export const contactTitle = 'contactTitle';

export const customTravel = 'customTravel';


